import React from "react";
import { motion } from "framer-motion";
import BackgroundVideo from "../components/Background-Video";
import PageTitle from "../partials/Page-Title";
import { Link } from "react-router-dom";
import TitleIcon from "../images/header-icons/connectedlaptop.svg";
import BackgroundImage from "../images/landing-page-bg/Connected-laptop@2x.png";

const ConnectedLaptop = () => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="w-screen h-[calc(100vh-172px)] relative top-[120px] 2xl:top-[172px] left-0 m-auto zoom-8">
            <PageTitle icon={TitleIcon} header="Connected Laptop" />
            <BackgroundVideo
                image={BackgroundImage}
                alt={"Background Image"}
                imageclasses="absolute 2xl:-top-[165px] -top-[140px]"
            />
            <div className="h-[calc(100vh-235px)] 2xl:h-[calc(100vh-260px)] absolute bottom-0 w-full">
                <motion
                    className="font-semibold 3xl:left-[25%] 3xl:top-[2%] left-[22%] -top-[6%] 2xl:left-[25%] 2xl:-top-[4%] rounded-full absolute bg-[#6E2585] w-[180px] h-[180px] 2xl:w-[226px] text-[#ffffff] 2xl:h-[226px] flex justify-center items-center align-middle text-center text-base 2xl:text-[20px] font-[] uppercase font-proxima-nova"
                >
                    <p>
                        EMPOWERING THE MOBILE WORKER
                    </p>
                </motion>
                <motion.div
                    whileHover={{
                        backgroundColor: ["#6E2585", "#444444"],
                        transition: { duration: 0.3 },
                    }}
                    className="font-semibold 3xl:left-[14%] 3xl:top-[36%] left-[12%] top-[32%] 2xl:left-[14%] 2xl:top-[27%] rounded-full text-center absolute bg-[#6E2585] w-[90px] h-[90px] 2xl:w-[126px] text-white 2xl:h-[126px] flex justify-center items-center align-middle text-[10px] 2xl:text-[15px] uppercase font-proxima-nova"
                >
                    <Link to="/connected-laptop/customer-office">
                        CUSTOMER <br/>OFFICE
                    </Link>
                </motion.div>
                <motion.div
                    whileHover={{
                        backgroundColor: ["#6E2585", "#444444"],
                        transition: { duration: 0.3 },
                    }}
                    className=" font-semibold left-[34%] top-[30%] 2xl:left-[36%] 2xl:top-[25%] rounded-full absolute bg-[#6E2585] text-center w-[90px] h-[90px] 2xl:w-[126px] text-white 2xl:h-[126px] flex justify-center items-center align-middle text-[10px] 2xl:text-[15px] uppercase font-proxima-nova"
                >
                    <Link to="/connected-laptop/on-the-move">ON THE <br/>MOVE</Link>
                </motion.div>

                <motion.div
                    whileHover={{
                        backgroundColor: ["#6E2585", "#444444"],
                        transition: { duration: 0.3 },
                    }}
                    className="font-semibold left-[32%] top-[62%] 2xl:left-[35%] 2xl:top-[55%] rounded-full absolute bg-[#6E2585] text-center w-[90px] h-[90px] 2xl:w-[126px] text-white 2xl:h-[126px] flex justify-center items-center align-middle text-[10px] 2xl:text-[15px] uppercase font-proxima-nova"
                >
                    <Link to="/connected-laptop/work-from-home">WORK FROM <br/>HOME</Link>
                </motion.div>
                <motion.div
                    whileHover={{
                        backgroundColor: ["#444444", "#444444"],
                        transition: { duration: 0.3 },
                    }}
                    className="font-semibold left-[68%] top-[12%] 2xl:left-[70%] 2xl:top-[15%] rounded-full absolute bg-[#444444] w-[180px] h-[180px] 2xl:w-[226px] text-white 2xl:h-[226px] text-center flex justify-center items-center align-middle text-base 2xl:text-[20px] uppercase font-proxima-nova"
                >
                    <Link to="/connected-laptop/construction-site-productivity">
                        CONSTRUCTION <br/>SITE <br/>PRODUCTIVITY
                    </Link>
                </motion.div>
            </div>
        </motion.div>
    );
};

export default ConnectedLaptop;

